import { useNavigate, useLocation } from 'react-router-dom';
import { ShoppingCart, ChevronsLeft , UsersIcon, FileText, Utensils,LayoutDashboard , X, Cookie } from 'lucide-react';

const AdminSidebar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { id: 'users', label: 'Dashboard', icon: LayoutDashboard , path: '/admin/' },
    { id: 'users', label: 'Users', icon: UsersIcon, path: '/admin/users' },
    { id: 'orders', label: 'Orders', icon: ShoppingCart, path: '/admin/orders' },
    { id: 'restaurant', label: 'Restaurants', icon: Utensils, path: '/admin/restaurant' },
    { id: 'categories', label: 'Categories ', icon: Cookie, path: '/admin/categories' },
    { id: 'restaurant-applications', label: 'Partner Applications', icon: FileText, path: '/admin/restaurant-applications' },
    { id: 'home', label: 'GrabGrub Page', icon: ChevronsLeft , path: '/' },
  ];

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar Panel */}
      <div
        className={`
    fixed top-0 left-0 h-screen w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50
    ${isOpen ? 'translate-x-0' : '-translate-x-full'}
    lg:translate-x-0  /* keep visible on large */
  `}
      >

        {/* Sidebar Header */}
        <div className="p-4 lg:p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-lg lg:text-xl font-bold text-gray-800">Super Admin</h2>
            <button
              onClick={() => setIsOpen(false)}
              className="lg:hidden text-gray-500 hover:text-gray-700"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Sidebar Navigation */}
        <nav className="p-2 lg:p-4">
          <ul className="space-y-1 lg:space-y-2">
            {menuItems.map(({ id, label, icon: Icon, path }) => {
              const isActive = location.pathname === path;
              return (
                <li key={id}>
                  <button
                    onClick={() => {
                      navigate(path);
                      setIsOpen(false);
                    }}
                    className={`w-full flex items-center px-3 lg:px-4 py-2 lg:py-3 text-left rounded-lg transition-colors text-sm lg:text-base
                      ${isActive
                        ? 'bg-blue-100 text-blue-700 font-medium'
                        : 'text-gray-700 hover:bg-gray-100'}
                    `}
                  >
                    <Icon className="w-4 lg:w-5 h-4 lg:h-5 mr-2 lg:mr-3" />
                    {label}
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default AdminSidebar;
